module.exports = __webpack_public_path__ + "img/main.bd3d2c9e.png";